import './index.scss';

function HeaderLinkDivider() {
    return <span className="header-link-divider border-start border-light my-auto" />
}

export default HeaderLinkDivider;